import { useTranslation } from 'react-i18next';
import { OperationType } from 'enums/modules/operations/operationType';

const useOperationTypeName = (): { getOperationTypeName: (type: OperationType) => string } => {
  const { t } = useTranslation();

  const getOperationTypeName = (type: OperationType): string => {
    switch (type) {
      case OperationType.BuyAsset:
        return t('operationTypeBuyAsset');
      case OperationType.SellAsset:
        return t('operationTypeSellAsset');
      case OperationType.BlockFunds:
        return t('operationTypeBlockFunds');
      case OperationType.UnblockFunds:
        return t('operationTypeUnblockFunds');
      case OperationType.DealFee:
        return t('operationTypeDealFee');
      case OperationType.SuccessFee:
        return t('operationTypeSuccessFee');
      case OperationType.UnlockAsset:
        return t('operationTypeUnlockAsset');
      default:
        return t('operationTypeUnknown');
    }
  };

  return { getOperationTypeName };
};

export default useOperationTypeName;
